import React from 'react';

const ACCREDITATIONS = [
  {
    id: 1,
    badge: 'NABCB',
    badgeColor: '#00AFEF',
    icon: '🏛️',
    title: 'NABCB Accreditation',
    subtitle: 'ISO/IEC 17020 Type-A Inspection Body',
    tag: 'International Accreditation',
    body: [
      'AQMCS is accredited by NABCB (member of International Accreditation Forum (IAF), International Laboratory Accreditation Cooperation (ILAC), and Asia Pacific Accreditation Cooperation (APAC) as well as signatory to their MLAs / MRAs.) as Type-A Inspection Body in accordance with ISO/IEC 17020.',
    ],
    memberships: ['IAF Member', 'ILAC Member', 'APAC Member', 'MLA/MRA Signatory'],
  },
  {
    id: 2,
    badge: 'QCI',
    badgeColor: '#0d9e6a',
    icon: '📋',
    title: 'QCI Empanelment',
    subtitle: 'ZED Assessment & FSSAI Hygiene Rating',
    tag: 'QCI Empanelment',
    body: [
      'AQMCS has been empanelled as an Assessment Agency for the MSME Sustainable (ZED) Certification Scheme.',
      'AQMCS has been recognised as a Hygiene Rating Auditing Agency under the Hygiene Rating Scheme owned by Food Safety and Standards Authority of India (FSSAI is a statutory body under the administration of the Ministry of Health and Family Welfare, Government of India).',
    ],
    memberships: ['ZED Assessment Agency', 'FSSAI Hygiene Rating Auditor', 'MoMSME Recognised', 'Ministry of Health Approved'],
  },
  {
    id: 3,
    badge: 'OIL',
    badgeColor: '#d97706',
    icon: '🛢️',
    title: 'OIL, ONGC & NTPC Empanelled',
    subtitle: 'Third Party Inspection Agency for OIL & NTPC Tenders',
    tag: 'OIL & NTPC',
    body: [
      'AQMCS has been empanelled with OIL and NTPC as a Third Party Inspection Agency (TPIA) for authentication of bidder documents.',
    ],
    memberships: ['TPIA — IOCL', 'Bid Document Authentication', 'PSU Approved Agency'],
  },
];

export default function AccreditationPage({ setPage }) {
  return (
    <main className="page" id="main-content">
      {/* ── PAGE HERO ── */}
      <header className="page-hero">
        <div className="ph-inner">
          <nav className="breadcrumb" aria-label="Breadcrumb">
            <span onClick={() => { setPage('Home'); window.scrollTo(0, 0); }}>Home</span>
            <span className="sep">/</span>
            <span className="cur">Accreditation</span>
          </nav>
          <h1>Accreditation & Recognition</h1>
          <p>
          </p>
        </div>
      </header>

      {/* ── INTRO TRUST STRIP ── */}
      <div className="accred-trust-strip">
        <div className="sec-inner">
          <div className="accred-trust-grid">
            {[
              { icon: '✅', label: 'NABCB Accredited', sub: 'ISO/IEC 17020 Type-A IB' },
              { icon: '🏅', label: 'QCI Empanelled', sub: 'ZED Assessment Agency' },
              { icon: '🍽️', label: 'FSSAI Recognized', sub: 'TPAA & HRAA' },
              { icon: '🛢️', label: 'OIL, ONGC & NTPC Empanelled', sub: 'TPIA for Tender document verification' },
            ].map((item, i) => (
              <div key={i} className="accred-trust-item">
                <span className="accred-trust-icon">{item.icon}</span>
                <div>
                  <div className="accred-trust-label">{item.label}</div>
                  <div className="accred-trust-sub">{item.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── ACCREDITATION CARDS ── */}
      <section className="section" aria-labelledby="accred-heading">
        <div className="sec-inner">
          <div className="sec-tag">Our Accreditation & Recognization</div>
          <h2 className="sec-title" id="accred-heading">
            
          </h2>
          <p className="sec-lead" style={{ marginBottom: '3.5rem' }}>

          </p>

          <div className="accred-cards-list">
            {ACCREDITATIONS.map((acc, i) => (
              <article key={acc.id} className="accred-card" aria-labelledby={`accred-title-${acc.id}`}>
                {/* Left: number + icon */}
                <div className="accred-card-left">
                  <div className="accred-step-num"></div> {/* {String(acc.id).padStart(2, '0')} */}
                  <div className="accred-icon-box" style={{ background: `${acc.badgeColor}18` }}>
                    <span>{acc.icon}</span>
                  </div>
                </div>

                {/* Right: content */}
                <div className="accred-card-body">
                  <div className="accred-card-header">
                    <div>
                      <span
                        className="accred-tag"
                        style={{ background: `${acc.badgeColor}15`, color: acc.badgeColor, borderColor: `${acc.badgeColor}30` }}
                      >
                        {acc.tag}
                      </span>
                      <h3 className="accred-card-title" id={`accred-title-${acc.id}`}>
                        {acc.title}
                      </h3>
                      <p className="accred-card-subtitle">{acc.subtitle}</p>
                    </div>
                    <div
                      className="accred-badge-pill"
                      style={{ background: `${acc.badgeColor}15`, color: acc.badgeColor, border: `1.5px solid ${acc.badgeColor}30` }}
                    >
                      {acc.badge}
                    </div>
                  </div>

                  <div className="accred-card-text">
                    {acc.body.map((para, pi) => (
                      <p key={pi}>{para}</p>
                    ))}
                  </div>
                    {/*
                  <div className="accred-memberships">
                    {acc.memberships.map((m, mi) => (
                      <span
                        key={mi}
                        className="accred-chip"
                        style={{ borderColor: `${acc.badgeColor}30`, color: acc.badgeColor }}
                      >
                        ✓ {m}
                      </span>
                    ))}
                  </div> */}
                  
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ── WHAT THIS MEANS
      <section className="section bg-light" aria-labelledby="means-heading">
        <div className="sec-inner">
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <div className="sec-tag center">Why It Matters</div>
            <h2 className="sec-title center" id="means-heading">
              What Our Accreditations Mean for You
            </h2>
            <p className="sec-lead" style={{ margin: '0 auto' }}>
              Choosing an accredited body is not just best practice — in many sectors it is a
              regulatory requirement. Here's what our credentials mean for your organisation.
            </p>
          </div>
          <div className="accred-benefits-grid">
            {[
              { icon: '🔒', title: 'Globally Recognised', desc: 'Our NABCB accreditation is backed by IAF, ILAC and APAC mutual recognition agreements, ensuring your certificates are accepted internationally.' },
              { icon: '⚖️', title: 'Independent & Impartial', desc: 'As an A-Type Inspection Body under ISO/IEC 17020, we operate with complete independence from our clients — no conflict of interest.' },
              { icon: '📊', title: 'Government Validated', desc: 'Our QCI empanelment means we are directly recognised by government bodies for ZED and FSSAI programmes — critical for MSME subsidy eligibility.' },
              { icon: '🏆', title: 'Technically Competent', desc: 'Accreditation requires regular third-party assessments of our technical competence, ensuring you always receive audits of the highest standard.' },
              { icon: '🌏', title: 'Internationally Aligned', desc: 'All our processes and procedures are aligned to ISO, IAF and ILAC guidelines, keeping you compliant with global best practices.' },
              { icon: '🤝', title: 'Trusted by Industry Leaders', desc: 'Our IOCL empanelment and AMTZ approval demonstrate trust from India\'s largest public sector enterprises and health technology bodies.' },
            ].map((b, i) => (
              <div key={i} className="accred-benefit-card">
                <div className="accred-benefit-icon">{b.icon}</div>
                <h4>{b.title}</h4>
                <p>{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section> ── */}

      {/* ── CTA ── */}
      <div className="cta-banner">
        <div className="cta-inner">
          <h2>Work with an <span className="cta-accent">Accredited</span> Body</h2>
          <p>
            Ensure your certification is globally recognised and fully compliant. Reach out
            to our team to discuss your requirements.
          </p>
          <button
            className="btn-blue"
            onClick={() => { setPage('Contact'); window.scrollTo(0, 0); }}
            style={{ fontSize: '1rem', padding: '1rem 2.5rem' }}
          >
            Get in Touch →
          </button>
        </div>
      </div>
    </main>
  );
}
